
import React, { useState, useEffect } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { postData, fetchData } from '../../Services/apiService';

const UserMenu = ({ userType, setProfiles }) => {
  const [userInfo, setUserInfo] = useState({}); 
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const isAdmin = user ? (user.isAdmin === 2 ? true : false) : false;

  const handleLogout = () => {
    localStorage.removeItem('user'); 
    sessionStorage.clear();

    window.location.href = '/';
  };
  useEffect(() => {
    

    fetchUserData();
    fetchProfilesData();
  }, []);

  const fetchUserData = async () => {
    const user = JSON.parse(localStorage.getItem('user')) || {};
    const idUser = user.id || 0;
    try {
      
      const data = await postData('AppUser/GetAppUserById', idUser);
      if (data.succes) {
        const additionalData = data.data;

        const updatedUser = {
          ...user, 
          ...additionalData,
        };
  
        setUserInfo(additionalData);
        localStorage.setItem('user', JSON.stringify(updatedUser));
       
      }
    
    } catch (error) {
      console.error('Error fetching data:', error);
     
    }
  };

  const fetchProfilesData = async () => {
    try {
      
      const data = await fetchData('AppUser/GetAppUserRoles');
      if (data?.succes) {
        const dataProfile = data.data;

        localStorage.setItem('profiles', JSON.stringify(dataProfile));
        
        const profiles = dataProfile.map(role => ({
          value: role.id,
          label: role.name
        }));
        
        if (profiles && setProfiles) {
          setProfiles(profiles);
        }
      }
      else {
      console.error("Error: La solicitud no fue exitosa.");
    }
    
    } catch (error) {
      console.error('Error fetching data:', error);
     
    }
  };

  return (
    <div className="row justify-content-end">
      <div className="col-sm-6 col-md-4">
        <DropdownButton id="dropdown-item-button" title={
          <span className="row d-flex align-items-center">
            <span className="col-3 col-lg-2">
              <span className="user-bubble">
                A
              </span>
            </span>
            <span className="col-7 col-lg-8 pl-24">
              <span className="row">
                <span className="col-12 justify-content-start d-flex body-1">
                  {userInfo.name}
                </span>
                <span className="col-12 justify-content-start d-flex caption">
                {userInfo.email}
                </span>
              </span>
            </span>
            <span className="col-1">
              <i class="fa-solid fa-chevron-down"></i>
            </span>
          </span>
        }>
          <Dropdown.ItemText ><a href="/Account">Tu cuenta</a></Dropdown.ItemText>
          <span className="dropdown-line"></span>
          <Dropdown.Item onClick={handleLogout}>Cerrar sesión</Dropdown.Item>
          
          {userType === 'super' && (
          <>
            <span className="dropdown-options">
              <span className="dropdown-line"></span>
              <span className="dropdown-line"></span>
              <Dropdown.Item href="/SuperDashboard">
                <i class="fa-solid fa-house"></i> Dashboard
              </Dropdown.Item>
              <span className="dropdown-line"></span>
              <Dropdown.Item href="/SuperStatistics">
                <i class="fa-solid fa-chart-line"></i> Estadísticas
              </Dropdown.Item>
              <span className="dropdown-line"></span>
              <Dropdown.Item href="/SuperUsers">
                <i class="fa-solid fa-users"></i> Usuarios
              </Dropdown.Item>
              <span className="dropdown-line"></span>
            
            </span>
          </>
          )}
          
          {userType === 'admin' && (
          <>
            <span className="dropdown-options">
              <span className="dropdown-line"></span>
              <span className="dropdown-line"></span>
              <Dropdown.Item href="/AdminDashboard">
                <i class="fa-solid fa-house"></i> Dashboard
              </Dropdown.Item>
              <span className="dropdown-line"></span>
              <Dropdown.Item href="/AdminStatistics">
                <i class="fa-solid fa-chart-line"></i> Estadísticas
              </Dropdown.Item>
              <span className="dropdown-line"></span>
              <Dropdown.Item href="/AdminUsers">
                <i class="fa-solid fa-users"></i> Usuarios
              </Dropdown.Item>
              <span className="dropdown-line"></span>
              {isAdmin && (
               <Dropdown.Item href="/AdminDocuments">
                <i class="fa-solid fa-file"></i> Documentos
               </Dropdown.Item>
              )}
              
             
            </span>
          </>
          )}
          
          {userType === 'manager' && (
          <>
            <span className="dropdown-options">
              <span className="dropdown-line"></span>
              <span className="dropdown-line"></span>
              <Dropdown.Item href="/ManagerDashboard">
                <i class="fa-solid fa-house"></i> Dashboard
              </Dropdown.Item>
              <span className="dropdown-line"></span>
              <Dropdown.Item href="/ManagerStatistics">
                <i class="fa-solid fa-chart-line"></i> Estadísticas
              </Dropdown.Item>
              <span className="dropdown-line"></span>
             
            </span>
          </>
          )}
        </DropdownButton>
      </div>
    </div>

  );
}

export default UserMenu;